module.exports = __webpack_public_path__ + "img/infrastructure-19.b1c3af86.png";